import { render, staticRenderFns } from "./pageSetTemplate.vue?vue&type=template&id=b0401ce2&scoped=true"
import script from "./pageSetTemplate.vue?vue&type=script&lang=js"
export * from "./pageSetTemplate.vue?vue&type=script&lang=js"
import style0 from "./pageSetTemplate.vue?vue&type=style&index=0&id=b0401ce2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0401ce2",
  null
  
)

export default component.exports